
import { Component, OnInit , ViewChild, ElementRef} from '@angular/core';
import { FormGroup, Validators, FormBuilder,FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import {AuthService}from '../../../../auth-guard/auth.service';
import { TemplateRef } from '@angular/core';

import { MtxDialog } from '@ng-matero/extensions/dialog';


@Component({
  selector: 'app-fccp-login',
  templateUrl: './fccp-login.html',
//   styleUrls:['./fccp-layout.scss']
})

export class FccpLogin implements OnInit {
  // @ViewChild('usernm') usernm: ElementRef;
  email = new FormControl('', [Validators.required, Validators.email]);
  forgotpasswordForm: FormGroup = new FormGroup({
    email: this.email
    // address: this.addressFormControl
  });
 
  paramdata:any;
  @ViewChild('forgotpwdmdl') forgotpwdmdl:TemplateRef<any>;
  @ViewChild('usernamefocus', {static: true}) usernamefocus:any;
  loginform: FormGroup;
  hide:any;
  formdialog:any;
  constructor(private fb: FormBuilder, private router: Router,private authservice:AuthService,public dialog: MtxDialog) {
    // window.location.href = 'https://aimchassis.com/aimview/login.php';
    this.hide = true;
    this.loginform = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

  }

  ngOnInit() {
    this.usernamefocus.nativeElement.focus();
    // this.usernm.nativeElement.focus();
  }

  getErrorMessage() {
    return this.email.hasError('required') ? 'You must enter a value' :
        this.email.hasError('email') ? 'Not a valid email' : '';
  }


  registeration()
  {
    this.router.navigate(['/fccp/fccpregisteration']);
  }

  login()
  {
    this.authservice.login( this.loginform.get('username').value, this.loginform.get('password').value);
  
  }

  showforgotpwd()
  {
    this.formdialog = this.dialog.originalOpen(this.forgotpwdmdl, {
            width: '420px',
        });
  }
  checkforgotpassworduserdata()
  {

    

        this.paramdata={};
        this.paramdata.user_email=this.forgotpasswordForm.get('email').value.toLowerCase();
        console.log((this.forgotpasswordForm.get('email').value).toLowerCase());
        // console.log(this.paramdata)

        this.authservice.selectdata('emailverification',this.paramdata).subscribe((getData:any) => 
        {
                console.log(getData);

                if(getData.length>0)
                {
                  console.log('if') ;

                  this.saveFinalData(getData[0].first_name);
                }
                else
                {
                  console.log('else') ;
                  
                  // this.showToast("top","Please Enter Registered Email Id","danger" );
                  this.authservice.showToasterror('top-center','Please Enter Registered Email Id',10000) ; 
                }
        
        },
          onerror => 
          {
            
            console.log("Error man"); 
          
          });


}

saveFinalData(firstname){


  let userdetails='action=poolforgotpassword&companyemail='+'support@aimchassis.com'+'&emailid='+this.forgotpasswordForm.get('email').value+'&firstname='+firstname;;
   this.authservice.sendemailurlresp('_jsusercreation.php?',userdetails,'text').subscribe((getData:any) => 
       {
         console.log(getData.length);
 
               if ( getData.length < 9 )    
                 {
                   this.updateforgotpassword(getData)
                   
                 }
               else 
                 {
                  
                  //  this.showToast("top","Problem In Data Insertion.Please Contact Customer Service","warning" );
                   this.authservice.showToasterror('top-full-width','Problem In Data Insertion.Please Contact Customer Service',10000) ;
                   console.log("Data Not Inserted"); 
                 
                 }
       },
     onerror => 
           {
           
             console.log("Error man"); 
           
           });
 
 
 }

 updateforgotpassword(password)
 {
     this.paramdata={};
     this.paramdata.user_email=this.forgotpasswordForm.get('email').value;
     this.paramdata.password=password;
      console.log(this.paramdata);
      this.authservice.IUDdata('updatePassword',this.paramdata,'text').subscribe((getData:any)=> {
        if(getData.length>0)
            {
              this.forgotpasswordForm.controls['email'].reset()
              this.authservice.showSuccess('top-center','Check your email for new temporary password',5000) ; 
              this.formdialog.close();
            }
            else
            {
              console.log('update password unsucessfull')
            }
 
           },
           onerror => 
           {
           
             console.log("Error man"); 
           
           });
 
 


}

 

}
